export default __webpack_public_path__ + "static/media/b919ae5e057a209f3f961c352f706353.4f1f78ad.gif";